import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0130. パスワード変更
 * [PUT] /me/password
 */
type Props = {
  password: string;
};

const updatePassword = (props: Props): Promise<any> => {
  return axios.put('/api/me/password', props);
};

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: updatePassword
  });
};